import { writable } from 'svelte/store'


export const userStores = writable(null)
